import { request } from './request'
/**
 * 
 * @param {删除员工} userId 
 */
export const delEmpByConditions = (userId) => {
  const url = `/api/v1/shop-user/${userId}`
  return request({
    method: 'DELETE',
    url: url
  })
}
/**
 * 
 * @param {获取员工列表} data 
 */
export const getEmployees = (data) => {
    const url = `/api/v1/shop-user/users?pageNum=${data.pageNum}&pageSize=${data.pageSize}`
    return request({
      method: 'get',
      url: url
    })
}
/**
 * 
 * @param {获取员工详细信息} userId 
 */
export const getEmployeeDetail = (userId) => {
  const url = `/api/v1/shop-user/${userId}`
  return request({
    method: 'get',
    url: url
  })
}
/**
 * 
 * @param {添加员工} data 
 */
export const addEmployee = (data) => {
    const url = '/api/v1/shop-user'
    return request({
      method: 'POST',
      url: url,
      data: data
    })
}
/**
 * 
 * @param {编辑员工} data 
 */
export const editEmployee = (data) => {
    const url = `/api/v1/shop-user/${data.userId}`
    return request({
      method: 'PUT',
      url: url,
      data: data
    })
}
/**
 * 
 * @param {获取权限列表} 
 */
export const getRoles = () => {
    const url = '/api/v1/permission/roles'
    return request({
      method: 'GET',
      url: url
    })
}
